import { StoreState } from "store/types";
import { ReceiptRulesState } from "./types";
import { createSelector } from "reselect";

const selectReceiptRules = (app: StoreState): ReceiptRulesState => app.receiptRules

export const getReceiptRulesForConnection = createSelector(
  selectReceiptRules,
  (state) => {
    return state.rules;
  }
);

export const getParsedRule = createSelector(selectReceiptRules, (state) => {
  return state.parsedRule;
});

export const getReceiptRulesConnectionId = createSelector(
  selectReceiptRules,
  (state) => state.rulesConnectionId
);